import React from 'react'
import { Modal } from '../../../components/modal/Modal'
import { classNameInput, notify } from '../../../../utils/utils'

const ModalConfirmarEliminacion = ({
	hookRepuestos,
	isOpenModalEliminar,
	closeModalEliminar,
	textoAnulacion,
	setTextoAnulacion,
	funcionListarTabla
}) => {

	const funcionEliminar = async () => {
        const jsonData = await hookRepuestos.anularRepuesto(hookRepuestos.repuesto.codRepuesto,textoAnulacion)
        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')

        if(jsonData.CodResultado == 1){
            closeModalEliminar()
            await funcionListarTabla()
        }
    }
  
	return (
		<Modal 
			isOpen={isOpenModalEliminar}
			title={'Eliminar repuesto'}
			action={funcionEliminar}
			closeModal={closeModalEliminar}
			textButtons = {{ confirm: 'Si', denied: 'No' }}
		>
			<div className='flex flex-col gap-5 items-center justify-center w-[400px] lg:w-full p-5'>
				<label className='text-xl'>¿Está seguro de eliminar el repuesto?</label>
				<textarea 
				value={textoAnulacion} 
				onChange={e => setTextoAnulacion(e.target.value)} 
				placeholder='(Motivo)' 
				className= {`${classNameInput} w-full h-[80px] p-5 caret-white`}
				></textarea>
			</div>
		</Modal>
	)
}

export default ModalConfirmarEliminacion